import axios, { AxiosResponse } from "axios";
import { forwardRef, useState } from "react";
import styled from "styled-components";
import MasterCopy from "../../common/models/MasterCopy";
import CloseCircle from "../../components/Buttons/CloseCircle";
import SimpleButton from "../../components/Buttons/SimpleButton";
import Column from "../../components/Column/Column";
import InputWithLabel from "../../components/InputWithLabel/InputWithLabel";
import { Modal } from "../../components/Modal/Modal";
import {
  CircularSVG,
  CustomCircle,
} from "../../components/ProgressBar/CircluarSVG";
import { QuantityPicker } from "../../components/QuantityPicker/QuantityPicker";
import Row from "../../components/Row/Row";
import RequiredText from "../../components/Text/RequiredText";
import Text from "../../components/Text/Text";
import { useAuth } from "../../hooks/useAuth";
import close_circle from "../../imgs/close-circle.svg";

interface ListToMarketplaceModalProps {
  theme: string;
  song: MasterCopy;
  showListToMarketplaceModal: boolean;
  onListToMarketplaceCloseClick: any;
  onListSuccess: any;
}

const SongCheckoutContainer = styled("div")`
  display: flex;
  border: 1px solid #ffffff90;
  border-radius: 12px;
  width: 100%;
`;

const SongCheckoutImg = styled("img")`
  width: 200px;
  height: 150px;
  position: relative;
  display: inline-block;
  overflow: hidden;
  margin: 0;
  border-radius: 12px;
`;

const ModalContainer = styled(Column)`
  gap: 1rem;
  padding-inline: 2rem;
  position: relative;
  background: #000d30;
  border-radius: 20px;
  min-width: 30%;
  text-align: left;
  padding-block: 3%;
  border: 1px solid #ffffff90;
`;

const ListToSecondaryMarketModal = forwardRef<
  HTMLDivElement,
  ListToMarketplaceModalProps
>(
  (
    {
      theme,
      song,
      showListToMarketplaceModal,
      onListToMarketplaceCloseClick,
      onListSuccess,
    },
    ref
  ) => {
    const auth = useAuth();
    const [placingOrder, setPlacingOrder] = useState(false);
    const [royalty, setRoyalty] = useState(2);

    const onListToMarketplace = async () => {

      const data = {'royalty_percentage': royalty, 
      'wallet_address': auth.user.wallet_address, 'contract_address': song.nft_address}
      axios
      .post(process.env.REACT_APP_BACKEND_URL + "/list_to_secondary_marketplace", JSON.stringify(data), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response: AxiosResponse) => {
        onListSuccess()
      });

    };

    return (
      <Modal
        backgroundOpacity={"rgb(0,43,66,0.9)"}
        ref={ref}
        show={showListToMarketplaceModal}
      >
        <ModalContainer>
          <CloseCircle
            bg={close_circle}
            onClick={onListToMarketplaceCloseClick}
          />
          <Text bold={true} size={"1.2rem"}>
            List to Marketplace
          </Text>
          <SongCheckoutContainer>
            <SongCheckoutImg src={song.song_cover_s3_link} />
            <Column style={{ justifyContent: "center", paddingLeft: "10%" }}>
              <Text bold={true}>{song.song_name}</Text>
            </Column>
          </SongCheckoutContainer>

          <InputWithLabel style={{ width: "50%" }}>
              <RequiredText>Royalty Percentage (%)</RequiredText>
              <QuantityPicker
                value={royalty}
                onChange={(newNumber) => {
                  setRoyalty(newNumber);
                }}
                max={10}
              />
            </InputWithLabel>

          <Row align="flex-start" style={{ marginTop: "1rem" }}>


            {!placingOrder ? (
              <SimpleButton
                style={{ marginLeft: "auto" }}
                onClick={onListToMarketplace}
              >
                Publish
              </SimpleButton>
            ) : (
              <SimpleButton style={{ marginLeft: "auto", paddingInline: "7%" }}>
                <CircularSVG>
                  <CustomCircle
                    cx="15"
                    cy="15"
                    r="10"
                    fill="none"
                    stroke-width="5"
                    stroke-miterlimit="10"
                  />
                </CircularSVG>
              </SimpleButton>
            )}
          </Row>
        </ModalContainer>
      </Modal>
    );
  }
);

export default ListToSecondaryMarketModal;
